import { render } from "./JalurPpdb.vue?vue&type=template&id=1e802a6a"
import script from "./JalurPpdb.vue?vue&type=script&lang=js"
export * from "./JalurPpdb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__